import { render, staticRenderFns } from "./AnalyzesPending.vue?vue&type=template&id=5ebd9648&"
import script from "./AnalyzesPending.vue?vue&type=script&lang=ts&"
export * from "./AnalyzesPending.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports